import { FC } from 'react'
import { useIsMobile } from '@wellesley/ui'

import { TRepost } from './types'
import RepostModal from './RepostModal'
import RepostDropdown from './RepostDropdown'
import RepostButton from './RepostButton'

const Repost: FC<TRepost> = (props) => {
  const { feed, counter, readonly, customContent, isHighlighted } = props
  const isMobile = useIsMobile()

  if (readonly && customContent) {
    return (
      <RepostButton
        feed={feed}
        counter={counter}
        isDisabled={false}
        isHighlighted={isHighlighted}
        customContent={customContent}
      />
    )
  }

  if (isMobile) {
    return <RepostModal {...props} />
  }

  return <RepostDropdown {...props} />
}

export default Repost
